import { ComboboxItem } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { clinicQKeys } from "./queryKeys";


const select = (res: any) => {
  //   console.log(res.data);

  if (res.data.length) {
    const categorizedData: ComboboxItem[] = [];

    for (const i in res.data) {
      const { type, _id } = res.data[i];

      categorizedData.push({ label: type as string, value: _id as string });
    }

    // console.log(categorizedData);
    return categorizedData;
  }
  return null;
};

interface QueryProps {
  category?: string;
  isEnabled?: boolean;
}

export const useGetClinicLabs = (options?: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: clinicQKeys.labsWithFilters({
      ...(options?.category && { category: options?.category ?? "" }),
    }),
    queryFn: () => {
      return api.get("clinic/lab-services", {
        params: {
          ...(options?.category && { category: options.category }),
        },
      });
    },
    select,
    staleTime: Infinity, // It does not change often and there are too many labs
    enabled: options?.isEnabled ?? true,

    onError: (res: any) => {
      console.error("[From Get Clinic Labs]", res);
      handleErrors(res, "query");
    },
  });
};
